export const ADD_TCIN_TO_BOARD = 'ADD_TCIN_TO_BOARD'
export const CLEAR_BOARD_DATA = 'CLEAR_BOARD_DATA'
export const SHOW_BULK_TCIN_DIALOG = 'SHOW_BULK_TCIN_DIALOG'
export const OPEN_RIGHT_DRAWER = 'OPEN_RIGHT_DRAWER'
export const OPEN_EXPLORER = 'OPEN_EXPLORER'
export const CLOSE_EXPLORER = 'CLOSE_EXPLORER'
export const CLOSE_RIGHT_DRAWER = 'CLOSE_RIGHT_DRAWER'
export const ADD_BOARD_ERROR_LIST = 'ADD_BOARD_ERROR_LIST'
